/**
 * @generated SignedSource<<d55fda4bef43fdf7e69b4505500fe694>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rPreApproveSubs",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectPreApproveUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateProjectTPayload",
        "kind": "LinkedField",
        "name": "updateProjectTByProjectId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectT",
            "kind": "LinkedField",
            "name": "projectT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectPreApproveUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateProjectTPayload",
        "kind": "LinkedField",
        "name": "updateProjectTByProjectId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectT",
            "kind": "LinkedField",
            "name": "projectT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "22636901ad7c37ded84be7cdb5d4511a",
    "id": null,
    "metadata": {},
    "name": "ProjectPreApproveUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation ProjectPreApproveUpdateMutation(\n  $input: UpdateProjectTByProjectIdInput!\n) {\n  updateProjectTByProjectId(input: $input) {\n    projectT {\n      projectId\n      rPreApproveSubs\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "4a7cab3dc4b8f1f49a1b5d906327bf38";

module.exports = node;
